import { render } from "./DeletedShields.vue?vue&type=template&id=1f85dbd8&lang=html"
import script from "./DeletedShields.vue?vue&type=script&lang=js"
export * from "./DeletedShields.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__